// extracted by mini-css-extract-plugin
export default {"waveContainer":"_1AIEC","circle":"_2H_CG","c1":"_1s-FY","c2":"_39yyd","c3":"_32sX4"};